import MagicShop from '@/components/game/scenes/MagicShop';
import StatusMeters from '@/components/game/sidebar/StatusMeters';
import store from "@/store";

export default [
	{
		path: 'magic-shop',
		name: "MAGIC_SHOP",
		components: {
			gameSpace: MagicShop,
			sidebar: StatusMeters,
		},
		beforeEnter(to, from, next) {
			if (store.getters["game/curveballs/active"]) {
				store.dispatch("game/curveballs/active/deactivate");
			}

			store.dispatch("game/funds/deposit");
			next();
		},
		meta: {
			transition: "curtain-pan",
		},
	},
	{
		path: 'magic-shop/complete',
		beforeEnter(to, from, next) {
			store.dispatch("game/tricks/purchase");
			next({ path: "/game/trick-selector" });
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/shop.routes.js